import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Button, Input, Popconfirm, DatePicker, message } from 'antd'
import moment from 'moment'
import styled from 'styled-components'
import { actions } from '../../redux/modules/templatesActions'
import { actions as itemActions } from '../../redux/modules/jobFunctions/itemActions'
import history from '../../history'
import config from '../../config'

const { API_BASE } = config

const Container = styled.div`
  padding: 25px;
`
const MarginTop = styled.div`
  margin-top: 15px;
`
const propTypes = {}
const { TextArea } = Input

class TemplatesDriverRequest extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentKey: 'driver_request',
      currentId: +this.props.match.params.templateId
    }
  }

  componentWillMount() {
    this.props.getTemplateById({
      templateType: this.state.currentKey,
      templateId: this.state.currentId
    })
    this.props.getAllItems()
  }

  componentDidUpdate(prevProps) {
    if (this.props.templatesActions && this.props.templatesActions.loadedTemplate) {
      if (
        this.props.templatesActions.loadedTemplate !== prevProps.templatesActions.loadedTemplate
      ) {
        const loadedTemplate = this.props.templatesActions.loadedTemplate.data[0]
        if (loadedTemplate) {
          this.setState({
            templateName: loadedTemplate.name,
            templateDescription: loadedTemplate.description,
            requestedBy: loadedTemplate.requested_by,
            requestedDate: loadedTemplate.requested_date,
            pointOfContact: loadedTemplate.point_of_contact,
            specialConditions: loadedTemplate.special_conditions,
            completedBy: loadedTemplate.completed_by,
            completeDate: loadedTemplate.complete_date
          })
        }
      }
    }
  }

  handleInputChange = (value, input) => {
    this.setState({ [input]: value })
  }

  handleCreate = () => {
    const {
      templateName,
      templateDescription,
      requestedBy,
      requestedDate,
      pointOfContact,
      specialConditions,
      completedBy,
      completeDate,
      currentId
    } = this.state

    const data = {
      templateName: templateName,
      templateDescription: templateDescription,
      requestedBy: requestedBy,
      requestedDate: moment(requestedDate).format('YYYY-MM-DD hh:mm:ss'),
      pointOfContact: pointOfContact,
      specialConditions: specialConditions,
      completedBy: completedBy,
      completeDate: moment(completeDate).format('YYYY-MM-DD hh:mm:ss'),
      estimate_template_id: currentId
    }
    if (currentId === 0) {
      this.props.createTemplate({
        templateType: 'driver_request',
        content: data,
        userId: this.props.authentication.user.userId
      })
    } else {
      this.props.saveTemplate({
        templateId: this.state.currentId,
        templateType: 'driver_request',
        content: data,
        userId: this.props.authentication.user.userId
      })
    }

    message.success('Changes saved.')
    this.setState({ contentData: null, currentId: 0, modalVisible: false })
  }

  confirmDelete = () => {
    this.props.deleteTemplate({
      templateId: this.state.currentId,
      templateType: 'driver_request'
    })

    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  render() {
    return (
      <Container>
        <h2>Driver Request Template</h2>
        <div className="row">
          <div className="col-md-12">
            <div>Template</div>
            <Input
              value={this.state.templateName}
              onChange={event => this.handleInputChange(event.target.value, 'templateName')}
            />
          </div>
        </div>
        <div>Description</div>
        <TextArea
          placeholder="Type in description..."
          rows={4}
          onChange={event => this.handleInputChange(event.target.value, 'templateDescription')}
          value={this.state.templateDescription}
        />
        <div className="row">
          <div className="col-md-6">
            <div>Requested By</div>
            <Input
              placeholder="Type in requested by name..."
              onChange={event => this.handleInputChange(event.target.value, 'requestedBy')}
              value={this.state.requestedBy}
            />
          </div>
          <div className="col-md-6">
            <div>Requested Date</div>
            <DatePicker
              format="MM-DD-YYYY HH:mm"
              showTime
              onChange={event => this.handleInputChange(event, 'requestedDate')}
              value={moment(this.state.requestedDate)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div>Needed By Date</div>
            <DatePicker
              format="MM-DD-YYYY HH:mm"
              showTime
              onChange={event => this.handleInputChange(event, 'neededByDate')}
              value={moment(this.state.neededByDate)}
            />
          </div>
          <div className="col-md-6">
            <div>Point of Contact</div>
            <Input
              placeholder="Type in point of contact..."
              onChange={event => this.handleInputChange(event.target.value, 'pointOfContact')}
              value={this.state.pointOfContact}
            />
          </div>
        </div>
        <div>Special Conditions</div>
        <TextArea
          placeholder="Type in any special conditions..."
          rows={4}
          onChange={event => this.handleInputChange(event.target.value, 'specialConditions')}
          value={this.state.specialConditions}
        />
        <div className="row">
          <div className="col-md-12">
            <MarginTop>
              {this.state.currentId > 0 && (
                <Fragment>
                  <Popconfirm
                    title="Are you sure you want to delete this record?"
                    onConfirm={this.confirmDelete}
                    onCancel={this.cancelDelete}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button type="danger" icon="delete" className="mr-2" />
                  </Popconfirm>
                  <a
                    href={`${API_BASE}/api/templates/driver_request/id/${
                      this.state.currentId
                    }/print`}
                    target="_blank"
                  >
                    <Button icon="printer" className="mr-2" />
                  </a>
                </Fragment>
              )}
            </MarginTop>
          </div>
        </div>
        <MarginTop>
          <Button onClick={() => history.goBack()}>Cancel</Button>{' '}
          <Button type="primary" onClick={() => this.handleCreate()}>
            {this.state.currentId === 0 && <span>Create Template</span>}
            {this.state.currentId > 0 && <span>Save Changes</span>}
          </Button>
        </MarginTop>
      </Container>
    )
  }
}

const mapStateToProps = ({ templatesActions, itemActions, authentication }, ownProps) => ({
  templatesActions,
  itemActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, itemActions), dispatch)
})

TemplatesDriverRequest.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TemplatesDriverRequest))



// WEBPACK FOOTER //
// ./src/containers/templates/driverRequestTemplate.js